function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Fragment } from 'react';
import { withTheme } from 'styled-components';
import { finectAPI } from '@finect/front-utils/finectAPI';
import { Strong } from '@finect/tabular-core/Strong';
import { AppLink } from '@finect/tabular-core/AppLink';
import { Small } from '@finect/tabular-core/Small';
import { AuthorInline, AuthorIcon } from '../../Author';
import { likeQuestion, unlikeQuestion } from '../utils/actions';
import { Toolbar } from '../../Reviews/ReviewCard/Toolbar/Toolbar';
import { Inner, Footer, Entry, Body } from '../../Reviews/ReviewCard/partials';
import { getQuestionPath } from '../utils';
import { IntroBlock, Title, AnswersBlock, FooterBlock, MoreAuthorsBlock, IconsBlock, ActionLine } from './partials';
import { Answer } from './Answer';
export var QuestionCard = function (_React$Component) {
  _inherits(QuestionCard, _React$Component);
  var _super = _createSuper(QuestionCard);
  function QuestionCard() {
    var _this;
    _classCallCheck(this, QuestionCard);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      liked: false,
      likes: _this.props.question.socialStats.likes,
      editing: false,
      deleted: false
    });
    _defineProperty(_assertThisInitialized(_this), "handleLike", function () {
      _this.state.liked ? _this.fetchUnlike() : _this.fetchLike();
      _this.setState({
        liked: !_this.state.liked,
        likes: !_this.state.liked ? _this.state.likes + 1 : _this.state.likes - 1
      });
    });
    return _this;
  }
  _createClass(QuestionCard, [{
    key: "fetchIsLiked",
    value: function fetchIsLiked() {
      var _this2 = this;
      var me = this.props.me;
      if (me && me.isLoggedIn) {
        finectAPI({
          version: 'v4',
          path: "users/me/likes/questions/".concat(this.props.question.id),
          method: 'GET',
          onSuccess: function onSuccess(_ref) {
            var data = _ref.data;
            _this2.setState({
              liked: data.me === 'like'
            });
          }
        });
      }
      this.setState({
        liked: false
      });
    }
  }, {
    key: "fetchLike",
    value: function fetchLike() {
      likeQuestion(this.props.question.id);
    }
  }, {
    key: "fetchUnlike",
    value: function fetchUnlike() {
      unlikeQuestion(this.props.question.id);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchIsLiked();
    }
  }, {
    key: "render",
    value: function render() {
      var liked = this.state.liked;
      var _this$props = this.props,
        question = _this$props.question,
        theme = _this$props.theme;
      var isOwn = false;
      var isAdviser = false;
      var path = getQuestionPath(theme, question);
      var sortedAnswers = _toConsumableArray(question.answers).sort(function (a, b) {
        var aScore = 10 * a.selected + (a.author.icon ? 1 : 0);
        var bScore = 10 * b.selected + (b.author.icon ? 1 : 0);
        return bScore - aScore;
      });
      var trailingAnswers = sortedAnswers.slice(1);
      return React.createElement(Inner, null, React.createElement(Entry, {
        isAdviser: isAdviser
      }, React.createElement(IntroBlock, null, React.createElement(AuthorInline, {
        author: question.author,
        loggedIn: true,
        withEntityCard: true
      }), React.createElement(ActionLine, null, " pregunta")), React.createElement(Body, null, React.createElement(Title, {
        href: path.url,
        "data-fi-event": "question-title",
        title: "Ver respuestas a la pregunta: ".concat(question.title)
      }, question.title), React.createElement(AnswersBlock, null, sortedAnswers.length ? React.createElement(Fragment, null, React.createElement("div", null, React.createElement(Strong, null, question.answers.length), " respuesta", question.answers.length !== 1 ? 's' : ''), React.createElement("div", null, sortedAnswers.slice(0, 1).map(function (answer, index) {
        return React.createElement(Answer, {
          answer: answer,
          question: question,
          key: index
        });
      }))) : React.createElement(Fragment, null, React.createElement("div", null, "\xBFSabes la respuesta?", ' ', React.createElement(AppLink, {
        href: path.url,
        title: question.title
      }, React.createElement(Strong, null, "Ayuda")), ' ', "a otras personas como ", question.author.displayName, " a resolver sus dudas."))), sortedAnswers.length - 1 > 0 ? React.createElement(FooterBlock, null, React.createElement(MoreAuthorsBlock, null, React.createElement(IconsBlock, null, trailingAnswers.slice(0, 4).map(function (_ref2) {
        var author = _ref2.author;
        return author;
      }).map(function (author, index) {
        return React.createElement(AuthorIcon, {
          key: index,
          author: author,
          withEntityCard: true,
          withLink: true
        });
      })), React.createElement("span", null, React.createElement(Small, null, React.createElement(AppLink, {
        href: path.url
      }, 'Ver ', sortedAnswers.length - 1, " respuesta", sortedAnswers.length - 1 !== 1 ? 's' : '', ' más'))))) : null), React.createElement(Footer, null, React.createElement(Toolbar, {
        like: {
          qty: this.state.likes,
          action: this.handleLike,
          done: liked,
          disable: isOwn ? 'No puedes realizar esta acción sobre tu propia pregunta' : ''
        },
        respond: {
          qty: question.stats.answers,
          path: path.url
        },
        share: {
          title: question.title,
          path: path.url
        }
      }))));
    }
  }]);
  return QuestionCard;
}(React.Component);
export default React.memo(withTheme(QuestionCard));